<div class="container">
  <ng-container *ngFor="let app of localApps; let $index = index">
    <div
      class="app-card htv-selectable htv-autofocus {{ $index === 0 ? 'htv-focus' : '' }}"
      (focus)="focusApp(app)"
      (click)="openApp(app)"
      tabindex="-1">
      <div class="app-card__inner app-card__app">
        <ng-container *ngIf="app.iconUrl">
          <img class="app-card__logo" [src]="app.iconUrl" alt="" />
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div class="app-card htv-selectable htv-autofocus" (focus)="focusClearData()" (click)="clearData()" tabindex="-1">
    <div class="app-card__inner app-card__clear">
      <span class="app-card__clear__desc">{{ 'PAGES.APPS.CLEAR_DESC' | translate }}</span>
      <span class="app-card__clear__auto">{{ 'PAGES.APPS.CLEAR_AUTO' | translate }}</span>
      <span class="app-card__clear__all">{{ 'PAGES.APPS.CLEAR_ALL' | translate }}</span>
    </div>
  </div>
</div>
